export default __webpack_public_path__ + "static/media/breakfast5.f8acc6f9.jpeg";